<div class="header-title">
    <div class="flex u-align-items-center u-pa-20">
      <div class="flex flex-align-center">
        <a routerLink="/button" aria-label="back"
          class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
          <span class="u-icon icon-chevron-left"></span>
          <span class="u-button-text">Back</span>
        </a>
      </div>
      <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
        <h1 class="font-semibold u-ma-0 flex header-title--name">
          Icons
        </h1>
      </div>
    </div>
    <div class="c-header__gradient"></div>
  </div>
  <div class="content">
    <pre class="code-usage">usage of code "<span>&#60;</span>em class="u-icon icon-corner-up-right"<span>&#62;</span><span>&#60;/</span>em<span>&#62;</span>"</pre>
        <div class="c-icon">
            <ul class="c-icon__list">
               <li class="c-icon__list-item">
                <em class="u-icon icon-check-circle-fill"></em>
                <span class="c-icon__list-item-text">icon-check-circle-fill</span>
                <span class="c-icon__list-item-code">\e9a6</span>
               </li>
               <li class="c-icon__list-item">
                <em class="u-icon icon-corner-up-right"></em>
                <span class="c-icon__list-item-text">icon-corner-up-right</span>
                <span class="c-icon__list-item-code">\e9a7</span>
               </li>
               <li class="c-icon__list-item">
                <em class="u-icon icon-refresh"></em>
                <span class="c-icon__list-item-text">icon-refresh</span>
                <span class="c-icon__list-item-code">\e9a8</span>
               </li>
               <li class="c-icon__list-item">
                <em class="u-icon icon-switch-vertical"></em>
                <span class="c-icon__list-item-text">icon-switch-vertical</span>
                <span class="c-icon__list-item-code">\e9a9</span>
               </li>
               <li class="c-icon__list-item">
                <em class="u-icon icon-upload"></em>
                <span class="c-icon__list-item-text">icon-upload</span>
                <span class="c-icon__list-item-code">\e9aa</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-about"></em>
                <span class="c-icon__list-item-text">icon-about</span>
                <span class="c-icon__list-item-code">\e900</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-add-to-favourite"></em>
                <span class="c-icon__list-item-text">icon-add-to-favourite</span>
                <span class="c-icon__list-item-code">\e901</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-alert-circle"></em>
                <span class="c-icon__list-item-text">icon-alert-circle</span>
                <span class="c-icon__list-item-code">\e902</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-alert-triangle"></em>
                <span class="c-icon__list-item-text">icon-alert-triangle</span>
                <span class="c-icon__list-item-code">\e903</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-bottom-arrow"></em>
                <span class="c-icon__list-item-text">icon-align-bottom-arrow</span>
                <span class="c-icon__list-item-code">\e904</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-center"></em>
                <span class="c-icon__list-item-text">icon-align-center</span>
                <span class="c-icon__list-item-code">\e905</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-justify"></em>
                <span class="c-icon__list-item-text">icon-align-justify</span>
                <span class="c-icon__list-item-code">\e906</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-left"></em>
                <span class="c-icon__list-item-text">icon-align-left</span>
                <span class="c-icon__list-item-code">\e907</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-right"></em>
                <span class="c-icon__list-item-text">icon-align-right</span>
                <span class="c-icon__list-item-code">\e908</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-align-top-arrow"></em>
                <span class="c-icon__list-item-text">icon-align-top-arrow</span>
                <span class="c-icon__list-item-code">\e909</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-animation"></em>
                <span class="c-icon__list-item-text">icon-animation</span>
                <span class="c-icon__list-item-code">\e90a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-arrow-narrow-down"></em>
                <span class="c-icon__list-item-text">icon-arrow-narrow-down</span>
                <span class="c-icon__list-item-code">\e90b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-arrow-narrow-up"></em>
                <span class="c-icon__list-item-text">icon-arrow-narrow-up</span>
                <span class="c-icon__list-item-code">\e90c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-award"></em>
                <span class="c-icon__list-item-text">icon-award</span>
                <span class="c-icon__list-item-code">\e90d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-backpack"></em>
                <span class="c-icon__list-item-text">icon-backpack</span>
                <span class="c-icon__list-item-code">\e90e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bar-chart-square"></em>
                <span class="c-icon__list-item-text">icon-bar-chart-square</span>
                <span class="c-icon__list-item-code">\e90f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bell"></em>
                <span class="c-icon__list-item-text">icon-bell</span>
                <span class="c-icon__list-item-code">\e910</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bold"></em>
                <span class="c-icon__list-item-text">icon-bold</span>
                <span class="c-icon__list-item-code">\e911</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-book-closed"></em>
                <span class="c-icon__list-item-text">icon-book-closed</span>
                <span class="c-icon__list-item-code">\e912</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-book-open"></em>
                <span class="c-icon__list-item-text">icon-book-open</span>
                <span class="c-icon__list-item-code">\e913</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bookmark"></em>
                <span class="c-icon__list-item-text">icon-bookmark</span>
                <span class="c-icon__list-item-code">\e914</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bookshelf-icon"></em>
                <span class="c-icon__list-item-text">icon-bookshelf-icon</span>
                  <span class="c-icon__list-item-code">\e915</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bookshelf"></em>
                <span class="c-icon__list-item-text">icon-bookshelf</span>
                <span class="c-icon__list-item-code">\e916</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-bookshelf2"></em>
                <span class="c-icon__list-item-text">icon-bookshelf2</span>
                <span class="c-icon__list-item-code">\e917</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-briefcase"></em>
                <span class="c-icon__list-item-text">icon-briefcase</span>
                <span class="c-icon__list-item-code">\e918</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-brush"></em>
                <span class="c-icon__list-item-text">icon-brush</span>
                <span class="c-icon__list-item-code">\e919</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-building"></em>
                <span class="c-icon__list-item-text">icon-building</span>
                <span class="c-icon__list-item-code">\e91a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-calendar-plus"></em>
                <span class="c-icon__list-item-text">icon-calendar-plus</span>
                <span class="c-icon__list-item-code">\e91b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-calendar"></em>
                <span class="c-icon__list-item-text">icon-calendar</span>
                <span class="c-icon__list-item-code">\e91c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-check-circle-2"></em>
                <span class="c-icon__list-item-text">icon-check-circle-2</span>
                <span class="c-icon__list-item-code">\e91d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-check-circle"></em>
                <span class="c-icon__list-item-text">con-check-circle</span>
                <span class="c-icon__list-item-code">\e91e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-check"></em>
                <span class="c-icon__list-item-text">icon-check</span>
                <span class="c-icon__list-item-code">\e91f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-down-double"></em>
                <span class="c-icon__list-item-text">icon-chevron-down-double</span>
                <span class="c-icon__list-item-code">\e920</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-down"></em>
                <span class="c-icon__list-item-text">icon-chevron-down</span>
                <span class="c-icon__list-item-code">\e921</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-left-double"></em>
                <span class="c-icon__list-item-text">icon-chevron-left-double</span>
                <span class="c-icon__list-item-code">\e922</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-left"></em>
                <span class="c-icon__list-item-text">icon-chevron-left</span>
                <span class="c-icon__list-item-code">\e923</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-right-double"></em>
                <span class="c-icon__list-item-text">icon-chevron-right-double</span>
                <span class="c-icon__list-item-code">\e924</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-right"></em>
                <span class="c-icon__list-item-text">icon-chevron-right</span>
                <span class="c-icon__list-item-code">\e925</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-selector-horizontal"></em>
                <span class="c-icon__list-item-text">icon-chevron-selector-horizontal</span>
                <span class="c-icon__list-item-code">\e926</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-selector-vertical"></em>
                <span class="c-icon__list-item-text">icon-chevron-selector-vertical</span>
                <span class="c-icon__list-item-code">\e927</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-up-double"></em>
                <span class="c-icon__list-item-text">icon-chevron-up-double</span>
                <span class="c-icon__list-item-code">\e928</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-chevron-up"></em>
                <span class="c-icon__list-item-text">icon-chevron-up</span>
                <span class="c-icon__list-item-code">\e929</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-clipboard-check"></em>
                <span class="c-icon__list-item-text">icon-clipboard-check</span>
                <span class="c-icon__list-item-code">\e92a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-clipboard"></em>
                <span class="c-icon__list-item-text">icon-clipboard</span>
                <span class="c-icon__list-item-code">\e92b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-clock"></em>
                <span class="c-icon__list-item-text">icon-clock</span>
                <span class="c-icon__list-item-code">\e92c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-close"></em>
                <span class="c-icon__list-item-text">icon-close</span>
                <span class="c-icon__list-item-code">\e92d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-copy"></em>
                <span class="c-icon__list-item-text">icon-copy</span>
                <span class="c-icon__list-item-code">\e92e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-cube"></em>
                <span class="c-icon__list-item-text">icon-cube</span>
                <span class="c-icon__list-item-code">\e92f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-cursor-02"></em>
                <span class="c-icon__list-item-text">icon-cursor-02</span>
                <span class="c-icon__list-item-code">\e930</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-cursor-click"></em>
                <span class="c-icon__list-item-text">icon-cursor-click</span>
                <span class="c-icon__list-item-code">\e931</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-cursor"></em>
                <span class="c-icon__list-item-text">icon-cursor</span>
                <span class="c-icon__list-item-code">\e932</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-delete"></em>
                <span class="c-icon__list-item-text">icon-delete</span>
                <span class="c-icon__list-item-code">\e933</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-diamond"></em>
                <span class="c-icon__list-item-text">icon-diamond</span>
                <span class="c-icon__list-item-code">\e934</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-dotpoints"></em>
                <span class="c-icon__list-item-text">icon-dotpoints</span>
                <span class="c-icon__list-item-code">\e935</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-dots-horizontal"></em>
                <span class="c-icon__list-item-text">icon-dots-horizontal</span>
                <span class="c-icon__list-item-code">\e936</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-dots-vertical"></em>
                <span class="c-icon__list-item-text">icon-dots-vertical</span>
                <span class="c-icon__list-item-code">\e937</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-download"></em>
                <span class="c-icon__list-item-text">icon-download</span>
                <span class="c-icon__list-item-code">\e938</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-drag-and-drop"></em>
                <span class="c-icon__list-item-text">icon-drag-and-drop</span>
                <span class="c-icon__list-item-code">\e939</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-eBook"></em>
                <span class="c-icon__list-item-text">icon-eBook</span>
                <span class="c-icon__list-item-code">\e93a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-edit"></em>
                <span class="c-icon__list-item-text">icon-edit</span>
                <span class="c-icon__list-item-code">\e93b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-expand"></em>
                <span class="c-icon__list-item-text">icon-expand</span>
                <span class="c-icon__list-item-code">\e93c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-eye-off"></em>
                <span class="c-icon__list-item-text">icon-eye-off</span>
                <span class="c-icon__list-item-code">\e93d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-eye"></em>
                <span class="c-icon__list-item-text">icon-eye</span>
                <span class="c-icon__list-item-code">\e93e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-fast-backward"></em>
                <span class="c-icon__list-item-text">icon-fast-backward</span>
                <span class="c-icon__list-item-code">\e93f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-fast-forward"></em>
                <span class="c-icon__list-item-text">icon-fast-forward</span>
                <span class="c-icon__list-item-code">\e941</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file-check"></em>
                <span class="c-icon__list-item-text">icon-file-check</span>
                <span class="c-icon__list-item-code">\e941</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file-heart"></em>
                <span class="c-icon__list-item-text">icon-file-heart</span>
                <span class="c-icon__list-item-code">\e942</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file-import"></em>
                <span class="c-icon__list-item-text">icon-file-import</span>
                <span class="c-icon__list-item-code">\e943</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file-plus"></em>
                <span class="c-icon__list-item-text">icon-file-plus</span>
                <span class="c-icon__list-item-code">\e944</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file-search"></em>
                <span class="c-icon__list-item-text">icon-file-search</span>
                <span class="c-icon__list-item-code">\e945</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-file"></em>
                <span class="c-icon__list-item-text">icon-file</span>
                <span class="c-icon__list-item-code">\e946</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-filter-funnel"></em>
                <span class="c-icon__list-item-text">icon-filter-funnel</span>
                <span class="c-icon__list-item-code">\e947</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-filter"></em>
                <span class="c-icon__list-item-text">icon-filter</span>
                <span class="c-icon__list-item-code">\e948</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-folder-question"></em>
                <span class="c-icon__list-item-text">icon-folder-question</span>
                <span class="c-icon__list-item-code">\e949</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-globe"></em>
                <span class="c-icon__list-item-text">icon-globe</span>
                <span class="c-icon__list-item-code">\e94a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-graduation-hat"></em>
                <span class="c-icon__list-item-text">icon-graduation-hat</span>
                <span class="c-icon__list-item-code">\e94b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-grid"></em>
                <span class="c-icon__list-item-text"></span>
                <span class="c-icon__list-item-code">\e94c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-hamburger"></em>
                <span class="c-icon__list-item-text">icon-hamburger</span>
                <span class="c-icon__list-item-code">\e94d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-help-circle"></em>
                <span class="c-icon__list-item-text"></span>
                <span class="c-icon__list-item-code">\e94e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-highlight"></em>
                <span class="c-icon__list-item-text"></span>
                <span class="c-icon__list-item-code">\e94f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-home"></em>
                <span class="c-icon__list-item-text">icon-home</span>
                <span class="c-icon__list-item-code">\e950</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-image"></em>
                <span class="c-icon__list-item-text">icon-image</span>
                <span class="c-icon__list-item-code">\e951</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-info-circle"></em>
                <span class="c-icon__list-item-text">icon-info-circle</span>
                <span class="c-icon__list-item-code">\e952</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-Institution"></em>
                <span class="c-icon__list-item-text">icon-Institution</span>
                <span class="c-icon__list-item-code">\e953</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-interactivity"></em>
                <span class="c-icon__list-item-text">icon-interactivity</span>
                <span class="c-icon__list-item-code">\e954</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-italic"></em>
                <span class="c-icon__list-item-text">icon-italic</span>
                <span class="c-icon__list-item-code">\e955</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-key"></em>
                <span class="c-icon__list-item-text">icon-key</span>
                <span class="c-icon__list-item-code">\e956</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-left-indent"></em>
                <span class="c-icon__list-item-text">icon-left-indent</span>
                <span class="c-icon__list-item-code">\e957</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-link-broken"></em>
                <span class="c-icon__list-item-text">icon-link-broken</span>
                <span class="c-icon__list-item-code">\e958</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-link-external"></em>
                <span class="c-icon__list-item-text">icon-link-external</span>
                <span class="c-icon__list-item-code">\e959</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-link"></em>
                <span class="c-icon__list-item-text">icon-link</span>
                <span class="c-icon__list-item-code">\e95a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-loading"></em>
                <span class="c-icon__list-item-text">icon-loading</span>
                <span class="c-icon__list-item-code">\e95b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-log-out"></em>
                <span class="c-icon__list-item-text">icon-log-out</span>
                <span class="c-icon__list-item-code">\e95c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-mask"></em>
                <span class="c-icon__list-item-text">icon-mask</span>
                <span class="c-icon__list-item-code">\e95d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-mask3"></em>
                <span class="c-icon__list-item-text">icon-mask3</span>
                <span class="c-icon__list-item-code">\e95e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-maximize"></em>
                <span class="c-icon__list-item-text">icon-maximize</span>
                <span class="c-icon__list-item-code">\e95f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-menu"></em>
                <span class="c-icon__list-item-text">icon-menu</span>
                <span class="c-icon__list-item-code">\e960</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-message-dots-circle"></em>
                <span class="c-icon__list-item-text">icon-message-dots-circle</span>
                <span class="c-icon__list-item-code">\e961</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-minimize"></em>
                <span class="c-icon__list-item-text">icon-minimize</span>
                <span class="c-icon__list-item-code">\e962</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-minus-circle"></em>
                <span class="c-icon__list-item-text">icon-minus-circle</span>
                <span class="c-icon__list-item-code">\e963</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-minus"></em>
                <span class="c-icon__list-item-text">icon-minus</span>
                <span class="c-icon__list-item-code">\e964</span>
              </li>
              <li class="c-icon__list-item">
                <div style="width: 24px; height: 24px; display: block;"><em class="u-icon icon-more-horizontal"></em></div>
                <span class="c-icon__list-item-text">icon-more-horizontal</span>
                <span class="c-icon__list-item-code">\e965</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-notes"></em>
                <span class="c-icon__list-item-text">icon-notes</span>
                <span class="c-icon__list-item-code">\e966</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pause-circle"></em>
                <span class="c-icon__list-item-text">icon-pause-circle</span>
                <span class="c-icon__list-item-code">\e967</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pdf"></em>
                <span class="c-icon__list-item-text">icon-pdf</span>
                <span class="c-icon__list-item-code">\e968</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pen-tool"></em>
                <span class="c-icon__list-item-text">icon-pen-tool</span>
                <span class="c-icon__list-item-code">\e969</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pen"></em>
                <span class="c-icon__list-item-text">icon-pen</span>
                <span class="c-icon__list-item-code">\e96a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pencil-line"></em>
                <span class="c-icon__list-item-text">icon-pencil-line</span>
                <span class="c-icon__list-item-code">\e96b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pencil"></em>
                <span class="c-icon__list-item-text">icon-pencil</span>
                <span class="c-icon__list-item-code">\e96c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-pilcrow"></em>
                <span class="c-icon__list-item-text">icon-pilcrow</span>
                <span class="c-icon__list-item-code">\e96d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-placeholder"></em>
                <span class="c-icon__list-item-text">icon-placeholder</span>
                <span class="c-icon__list-item-code">\e96e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-play"></em>
                <span class="c-icon__list-item-text">icon-play</span>
                <span class="c-icon__list-item-code">\e96f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-plus-circle"></em>
                <span class="c-icon__list-item-text">icon-plus-circle</span>
                <span class="c-icon__list-item-code">\e970</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-plus"></em>
                <span class="c-icon__list-item-text">icon-plus</span>
                <span class="c-icon__list-item-code">\e971</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-puzzle-piece"></em>
                <span class="c-icon__list-item-text">icon-puzzle-piece</span>
                <span class="c-icon__list-item-code">\e972</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-remove-to-favourite"></em>
                <span class="c-icon__list-item-text">icon-remove-to-favourite</span>
                <span class="c-icon__list-item-code">\e973</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-repeat"></em>
                <span class="c-icon__list-item-text">icon-repeat</span>
                <span class="c-icon__list-item-code">\e974</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-reverse-left"></em>
                <span class="c-icon__list-item-text">icon-reverse-left</span>
                <span class="c-icon__list-item-code">\e975</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-reverse-right"></em>
                <span class="c-icon__list-item-text">icon-reverse-right</span>
                <span class="c-icon__list-item-code">\e976</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-rewards"></em>
                <span class="c-icon__list-item-text">icon-rewards</span>
                <span class="c-icon__list-item-code">\e977</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-right-indent"></em>
                <span class="c-icon__list-item-text">icon-right-indent</span>
                <span class="c-icon__list-item-code">\e978</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-save"></em>
                <span class="c-icon__list-item-text">icon-save</span>
                <span class="c-icon__list-item-code">\e979</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-search-md"></em>
                <span class="c-icon__list-item-text">icon-search-md</span>
                <span class="c-icon__list-item-code">\e97a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-search"></em>
                <span class="c-icon__list-item-text">icon-search</span>
                <span class="c-icon__list-item-code">\e97b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-select-icon"></em>
                <span class="c-icon__list-item-text">icon-select-icon</span>
                <span class="c-icon__list-item-code">\e97c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-selection"></em>
                <span class="c-icon__list-item-text">icon-selection</span>
                <span class="c-icon__list-item-code">\e97d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-settings"></em>
                <span class="c-icon__list-item-text">icon-settings</span>
                <span class="c-icon__list-item-code">\e97e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-share"></em>
                <span class="c-icon__list-item-text">icon-share</span>
                <span class="c-icon__list-item-code">\e97f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-single-user"></em>
                <span class="c-icon__list-item-text">icon-single-user</span>
                <span class="c-icon__list-item-code">\e980</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-skip-back"></em>
                <span class="c-icon__list-item-text">icon-skip-back</span>
                <span class="c-icon__list-item-code">\e981</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-skip-forward"></em>
                <span class="c-icon__list-item-text">icon-skip-forward</span>
                <span class="c-icon__list-item-code">\e982</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-slideshow"></em>
                <span class="c-icon__list-item-text">icon-slideshow</span>
                <span class="c-icon__list-item-code">\e983</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-spacing-width"></em>
                <span class="c-icon__list-item-text">icon-spacing-width</span>
                <span class="c-icon__list-item-code">\e984</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-speedometer"></em>
                <span class="c-icon__list-item-text">icon-speedometer</span>
                <span class="c-icon__list-item-code">\e985</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-square"></em>
                <span class="c-icon__list-item-text">icon-square</span>
                <span class="c-icon__list-item-code">\e986</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-stand"></em>
                <span class="c-icon__list-item-text">icon-stand</span>
                <span class="c-icon__list-item-code">\e987</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-status-check-circle"></em>
                <span class="c-icon__list-item-text">icon-status-check-circle</span>
                <span class="c-icon__list-item-code">\e988</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-status-check"></em>
                <span class="c-icon__list-item-text">icon-status-check</span>
                <span class="c-icon__list-item-code">\e989</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-stop"></em>
                <span class="c-icon__list-item-text">icon-stop</span>
                <span class="c-icon__list-item-code">\e98a</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-strikethrough"></em>
                <span class="c-icon__list-item-text">icon-strikethrough</span>
                <span class="c-icon__list-item-code">\e98b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-subscript"></em>
                <span class="c-icon__list-item-text">icon-subscript</span>
                <span class="c-icon__list-item-code">\e98c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-tablet"></em>
                <span class="c-icon__list-item-text">icon-tablet</span>
                <span class="c-icon__list-item-code">\e98d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-test-generator"></em>
                <span class="c-icon__list-item-text">icon-test-generator</span>
                <span class="c-icon__list-item-code">\e98e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-tool"></em>
                <span class="c-icon__list-item-text">icon-tool</span>
                <span class="c-icon__list-item-code">\e98f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trash"></em>
                <span class="c-icon__list-item-text">icon-trash</span>
                <span class="c-icon__list-item-code">\e990</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-blank"></em>
                <span class="c-icon__list-item-text">icon-trophy-blank</span>
                <span class="c-icon__list-item-code">\e991</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-bronze"><span class="path1"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-bronze</span>
                <span class="c-icon__list-item-code">\e992</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-bronze"><span class="path2"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-bronze</span>
                <span class="c-icon__list-item-code">\e993</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-gold"><span class="path1"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-gold</span>
                <span class="c-icon__list-item-code">\e995</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-gold"><span class="path2"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-gold</span>
                <span class="c-icon__list-item-code">\e996</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-silver"><span class="path1"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-silver</span>
                <span class="c-icon__list-item-code">\e998</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy-silver"><span class="path2"></span></em>
                <span class="c-icon__list-item-text">icon-trophy-silver</span>
                <span class="c-icon__list-item-code">\e999</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-trophy"></em>
                <span class="c-icon__list-item-text">icon-trophy</span>
                <span class="c-icon__list-item-code">\e99b</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-type"></em>
                <span class="c-icon__list-item-text">icon-type</span>
                <span class="c-icon__list-item-code">\e99c</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-underline"></em>
                <span class="c-icon__list-item-text">icon-underline</span>
                <span class="c-icon__list-item-code">\e99d</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-user-circle"></em>
                <span class="c-icon__list-item-text">icon-user-circle</span>
                <span class="c-icon__list-item-code">\e99e</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-users"></em>
                <span class="c-icon__list-item-text">icon-users</span>
                <span class="c-icon__list-item-code">\e99f</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-video-recorder"></em>
                <span class="c-icon__list-item-text">icon-video-recorder</span>
                <span class="c-icon__list-item-code">\e9a0</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-volume-max"></em>
                <span class="c-icon__list-item-text">icon-volume-max</span>
                <span class="c-icon__list-item-code">\e9a1</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-volume-x"></em>
                <span class="c-icon__list-item-text">icon-volume-x</span>
                <span class="c-icon__list-item-code">\e9a2</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-x-close"></em>
                <span class="c-icon__list-item-text">icon-x-close</span>
                <span class="c-icon__list-item-code">\e9a3</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-zoom-in"></em>
                <span class="c-icon__list-item-text">icon-zoom-in</span>
                <span class="c-icon__list-item-code">\e9a4</span>
              </li>
              <li class="c-icon__list-item">
                <em class="u-icon icon-zoom-out"></em>
                <span class="c-icon__list-item-text">icon-zoom-out</span>
                <span class="c-icon__list-item-code">\e9a5</span>
              </li>
            </ul>
        </div>
  </div>